import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { LanguageSuggestionComponent } from '../language-suggestion/language-suggestion.component';

@Component({
  selector: 'layout-page-layout',
  imports: [RouterOutlet, FooterComponent, HeaderComponent, LanguageSuggestionComponent],
  templateUrl: './page-layout.component.html',
})
export class PageLayoutComponent {}
